import { Button } from "@/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import type {
  CurationColumn,
  ExtractionRow,
  ExtractionSearchNote,
} from "@/features/data-curation/types";

/** What a search for one value found, and where it looked. */
export const SearchNoteBody = ({ note }: { note: ExtractionSearchNote }) => (
  <div className="space-y-2">
    <p className="whitespace-pre-wrap break-words text-sm text-zinc-700">{note.note}</p>
    {note.searched.length > 0 && (
      <div>
        <p className="text-xs font-medium text-zinc-500">Searched</p>
        <ul className="mt-1 flex flex-wrap gap-1" aria-label="Places searched">
          {note.searched.map((place) => (
            <li
              key={place}
              className="break-all rounded-[3px] border border-zinc-200 bg-zinc-50 px-1.5 py-0.5 font-mono text-xs text-zinc-700"
            >
              {place}
            </li>
          ))}
        </ul>
      </div>
    )}
    <p className="text-xs text-zinc-500">
      {note.automatic
        ? "Paperclip wrote this note: the table reader read these documents and found no value."
        : "The agent wrote this note after its search."}
    </p>
  </div>
);

export interface SearchNoteTarget {
  row: ExtractionRow;
  column: CurationColumn;
  note: ExtractionSearchNote;
}

/** Where the search for the value of one empty cell looked. */
export const SearchNoteDialog = ({
  target,
  onClose,
}: {
  target: SearchNoteTarget | null;
  onClose: () => void;
}) => (
  <Dialog open={target != null} onOpenChange={(open) => !open && onClose()}>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle>{target?.column.label}: not found</DialogTitle>
        <DialogDescription>{target?.row.row_description}</DialogDescription>
      </DialogHeader>
      {target && <SearchNoteBody note={target.note} />}
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
